import initialState from './initialState';
import {
  FETCH_ACCOUNT_USER_INIT,
  FETCH_ACCOUNT_USER_SUCCESS,
  FETCH_ACCOUNT_USER_FAILURE,
  FETCH_ACCOUNT_USER_COUNT_INIT,
  FETCH_ACCOUNT_USER_COUNT_SUCCESS,
  FETCH_ACCOUNT_USER_COUNT_FAILURE,
  FETCH_ACCOUNT_USER_ROLL_INIT,
  FETCH_ACCOUNT_USER_ROLL_SUCCESS,
  FETCH_ACCOUNT_USER_ROLL_FAILURE,
  FETCH_ACCOUNT_USER_OPTIONS_TO_CREATE_USER_INIT,
  FETCH_ACCOUNT_USER_OPTIONS_TO_CREATE_USER_SUCCESS,
  FETCH_ACCOUNT_USER_OPTIONS_TO_CREATE_USER_FAILURE,
  FETCH_ACCOUNT_USER_GET_USER_TO_EDIT_INIT,
  FETCH_ACCOUNT_USER_GET_USER_TO_EDIT_SUCCESS,
  FETCH_ACCOUNT_USER_GET_USER_TO_EDIT_FAILURE,
  FETCH_ACCOUNT_USER_NO_LOADING_INIT,
  FETCH_ACCOUNT_USER_NO_LOADING_SUCCESS,
  FETCH_ACCOUNT_USER_NO_LOADING_FAILURE,
  UPDATE_ACCOUNT_USER_PASS_INIT,
  UPDATE_ACCOUNT_USER_PASS_SUCCESS,
  UPDATE_ACCOUNT_USER_PASS_FAILURE,
  SAVE_ACCOUNT_USER_INIT,
  SAVE_ACCOUNT_USER_SUCCESS,
  SAVE_ACCOUNT_USER_FAILURE,
  UPDATE_ACCOUNT_USER_INIT,
  UPDATE_ACCOUNT_USER_SUCCESS,
  UPDATE_ACCOUNT_USER_FAILURE,
  DELETE_ACCOUNT_USER_INIT,
  DELETE_ACCOUNT_USER_SUCCESS,
  DELETE_ACCOUNT_USER_FAILURE,
  ACTIVE_ACCOUNT_USER_INIT,
  ACTIVE_ACCOUNT_USER_SUCCESS,
  ACTIVE_ACCOUNT_USER_FAILURE,
  RESET_MODAL,
  RESET_ACCOUNT_USER,
  RESET_MODAL_FILE,
  FETCH_DOWNLOAD_ACCOUNT_USER_SUCCESS,
  FETCH_DOWNLOAD_ACCOUNT_USER_FAILURE,
  FETCH_DOWNLOAD_ACCOUNT_USER_INIT,
  FETCH_UPLOAD_ACCOUNT_USER_SUCCESS,
  FETCH_UPLOAD_ACCOUNT_USER_FAILURE,
  FETCH_UPLOAD_ACCOUNT_USER_INIT
} from '../../actions/account_user/types';

export default function accountUser(state = initialState, action) {
  switch (action.type) {
    case FETCH_ACCOUNT_USER_INIT:
      return {
        ...state,
        loading: true,
        error: null
      };
    case FETCH_ACCOUNT_USER_SUCCESS:
      return {
        ...state,
        datos: action.payload.data,
        error: null,
        loading: false,
        status: action.payload.status
      };
    case FETCH_ACCOUNT_USER_FAILURE:
      return {
        ...state,
        datos: {},
        error: action.payload,
        loading: false,
        status: 500
      };
    case FETCH_ACCOUNT_USER_COUNT_INIT:
      return {
        ...state,
        error: null
      };
    case FETCH_ACCOUNT_USER_COUNT_SUCCESS:
      return {
        ...state,
        count: action.payload.data,
        error: null,
        statusCount: action.payload.status
      };
    case FETCH_ACCOUNT_USER_COUNT_FAILURE:
      return {
        ...state,
        count: {},
        error: action.payload,
        statusCount: 500
      };
    case FETCH_ACCOUNT_USER_ROLL_INIT:
      return {
        ...state,
        loadingRoll: true,
        error: null
      };
    case FETCH_ACCOUNT_USER_ROLL_SUCCESS:
      return {
        ...state,
        datosRoll: action.payload.data,
        error: null,
        loadingRoll: false,
        statusRoll: action.payload.status
      };
    case FETCH_ACCOUNT_USER_ROLL_FAILURE:
      return {
        datosRoll: {},
        error: action.payload,
        loadingRoll: false
      };
    case FETCH_ACCOUNT_USER_OPTIONS_TO_CREATE_USER_INIT:
      return {
        ...state,
        optionsToCreateUserLoading: true,
        error: null
      };
    case FETCH_ACCOUNT_USER_OPTIONS_TO_CREATE_USER_SUCCESS:
      return {
        ...state,
        optionsToCreateUser: action.payload.data,
        error: null,
        optionsToCreateUserLoading: false,
        optionsToCreateUserStatus: action.payload.status
      };
    case FETCH_ACCOUNT_USER_OPTIONS_TO_CREATE_USER_FAILURE:
      return {
        optionsToCreateUser: {},
        error: action.payload,
        optionsToCreateUserLoading: false
      };
    case FETCH_ACCOUNT_USER_GET_USER_TO_EDIT_INIT:
      return {
        ...state,
        userToEditLoading: true,
        error: null
      };
    case FETCH_ACCOUNT_USER_GET_USER_TO_EDIT_SUCCESS:
      return {
        ...state,
        userToEdit: action.payload.data,
        error: null,
        userToEditLoading: false,
        userToEditStatus: action.payload.status
      };
    case FETCH_ACCOUNT_USER_GET_USER_TO_EDIT_FAILURE:
      return {
        userToEdit: {},
        error: action.payload,
        userToEditLoading: false
      };
    case FETCH_ACCOUNT_USER_NO_LOADING_INIT:
      return {
        ...state,
        error: null,
        loadingTable: true
      };
    case FETCH_ACCOUNT_USER_NO_LOADING_SUCCESS:
      return {
        ...state,
        datos: action.concat ? state.datos.concat(action.payload.data) : action.payload.data,
        error: null,
        status: action.payload.status,
        loadingTable: false
      };
    case FETCH_ACCOUNT_USER_NO_LOADING_FAILURE:
      return {
        ...state,
        loadingTable: false,
        status: 500
      };
    case SAVE_ACCOUNT_USER_INIT:
      return {
        ...state,
        error: null,
        loadingSave: true
      };
    case SAVE_ACCOUNT_USER_SUCCESS:
      return {
        ...state,
        dataSave: action.payload.data,
        error: null,
        loadingSave: false,
        statusSave: action.payload.status
      };
    case UPDATE_ACCOUNT_USER_INIT:
      return {
        ...state,
        error: null,
        loadingSave: true
      };
    case UPDATE_ACCOUNT_USER_SUCCESS:
      return {
        ...state,
        dataSave: action.payload.data,
        error: null,
        loadingSave: false,
        statusSave: action.payload.status
      };
    case UPDATE_ACCOUNT_USER_FAILURE:
      return {
        ...state,
        loadingSave: false,
        status: 500
      };
    case UPDATE_ACCOUNT_USER_PASS_INIT:
      return {
        ...state,
        error: null,
        loadingSave: true
      };
    case UPDATE_ACCOUNT_USER_PASS_SUCCESS:
      return {
        ...state,
        dataSave: action.payload.data,
        error: null,
        loadingSave: false,
        statusSave: action.payload.status
      };
    case UPDATE_ACCOUNT_USER_PASS_FAILURE:
      return {
        ...state,
        loadingSave: false,
        status: 500
      };
    case SAVE_ACCOUNT_USER_FAILURE:
      return {
        ...state,
        loadingSave: false,
        status: 500
      };
    case RESET_MODAL:
      return {
        ...state,
        loadingSave: false,
        statusSave: null,
        dataSave: {}, 
        userToEdit: {},
        userToEditLoading: false,
        userToEditStatus: null,
      };
    case RESET_ACCOUNT_USER:
      return {
        ...state,
        count: {},
        datos: {},
        loading: true,
        error: null,
        status: null,
        datosRoll: {},
        loadingRoll: true,
        statusRoll: null,
        loadingSave: false,
        statusSave: null,
        dataSave: {}
      };
    case DELETE_ACCOUNT_USER_INIT:
      return {
        ...state,
        error: null,
        loadingSave: true
      };
    case DELETE_ACCOUNT_USER_SUCCESS:
      return {
        ...state,
        dataSave: action.payload.data,
        error: null,
        loadingSave: false,
        statusSave: action.payload.status
      };
    case DELETE_ACCOUNT_USER_FAILURE:
      return {
        ...state,
        loadingSave: false,
        status: 500
      };
    case ACTIVE_ACCOUNT_USER_INIT:
      return {
        ...state,
        error: null,
        loadingSave: true
      };
    case ACTIVE_ACCOUNT_USER_SUCCESS:
      return {
        ...state,
        dataSave: action.payload.data,
        error: null,
        loadingSave: false,
        statusSave: action.payload.status
      };
    case RESET_MODAL_FILE:
      return {
        ...state,
        loadingFile: false,
        statusFile: null,
        datosFile: {}
      };
    case FETCH_DOWNLOAD_ACCOUNT_USER_INIT:
      return {
        ...state,
        loadingFile: true,
        error: null
      };
    case FETCH_DOWNLOAD_ACCOUNT_USER_SUCCESS:
      return {
        ...state,
        datosFile: action.payload.data,
        error: null,
        loadingFile: false,
        statusFile: action.payload.status
      };
    case FETCH_DOWNLOAD_ACCOUNT_USER_FAILURE:
      return {
        ...state,
        loadingFile: false,
        status: 500
      };
    case FETCH_UPLOAD_ACCOUNT_USER_INIT:
      return {
        ...state,
        loadingFile: true,
        error: null
      };
    case FETCH_UPLOAD_ACCOUNT_USER_SUCCESS:
      return {
        ...state,
        datosFile: action.payload.data,
        error: null,
        loadingFile: false,
        statusFile: action.payload.status
      };
    case FETCH_UPLOAD_ACCOUNT_USER_FAILURE:
      return {
        ...state,
        loadingFile: false,
        status: 500
      };
    case ACTIVE_ACCOUNT_USER_FAILURE:
      return {
        ...state,
        loadingSave: false,
        status: 500
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./source/client/reducers/account_user/index.js